/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_In_Use_HintInputs */

const vi_vehicle_in_use_hint = /** @type {(inputs: Vehicle_In_Use_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xe đang trong chuyến giao. Mở chi tiết xe để xem chuyến đang chạy hoặc kết thúc chuyến.`)
};

/**

* @param {Vehicle_In_Use_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_in_use_hint = /** @type {((inputs?: Vehicle_In_Use_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_In_Use_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_in_use_hint(inputs)
});